export default "__VITE_ASSET__DNCq$Rim__"